import React from "react";
import { render, screen } from "@testing-library/react";
import "@testing-library/jest-dom";
import { CompanyOperatingStatus } from "./CompanyOperatingStatus";

describe("CompanyOperatingStatus", () => {
  it("renders inactive status with date and acquirer", () => {
    render(
      <CompanyOperatingStatus
        company={{
          value: {
            operating_status: { value: "inactive" },
            status_date: { value: "2024-03-12" },
            acquirer: { value: { name: { value: "Acquirer Bio" } } },
          },
        }}
      />,
    );

    expect(screen.getByText("Inactive")).toBeInTheDocument();
    expect(screen.getByText("Status date: 2024-03-12")).toBeInTheDocument();
    expect(screen.getByText("Acquired by Acquirer Bio")).toBeInTheDocument();
  });

  it("renders inactive status without an acquirer", () => {
    render(
      <CompanyOperatingStatus
        company={{
          value: {
            operating_status: { value: "inactive" },
            status_date: { value: "2024-03-12" },
          },
        }}
      />,
    );

    expect(screen.getByText("Inactive")).toBeInTheDocument();
    expect(screen.getByText("Status date: 2024-03-12")).toBeInTheDocument();
    expect(screen.queryByText(/Acquired by/)).not.toBeInTheDocument();
  });

  it.each([
    ["active", { value: "active" }],
    ["missing", undefined],
  ])("renders nothing for %s status", (_label, operatingStatus) => {
    const { container } = render(
      <CompanyOperatingStatus
        company={{ value: { operating_status: operatingStatus } }}
      />,
    );

    expect(container).toBeEmptyDOMElement();
  });
});
